const TEXT = ["T BRAND", "TRADITIONAL ART", "240 GSM PREMIUM BIOWASH", "MODERN WEAR", "@TBRAND_111", "SAME ROOTS NEW STORIES"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {TEXT.map((t, i) => (
      <span key={t} className="flex items-center">
        <span className={`px-8 font-display text-6xl font-black uppercase italic md:text-8xl ${i % 2 ? "text-outline" : "text-white"}`}>{t}</span>
        <span className="h-4 w-4 rotate-45 bg-[#00FF66]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="overflow-hidden border-y border-white/10 bg-[#0A0A0B] py-8" data-testid="editorial-marquee" aria-label="T Brand marquee">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
